import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

export default function Register() {
  const { t, lang, register } = useApp();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', password: '', role: 'teacher', preferred_language: lang });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await register(form);
      toast.success(t('welcome') + ' ' + u.full_name);
      navigate({ admin: '/admin', teacher: '/teacher', student: '/student', parent: '/parent' }[u.role] || '/');
    } catch (err) {
      toast.error(err.response?.data?.detail || t('error'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main id="main" className="max-w-md mx-auto px-4 py-16" data-testid="register-page">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">{t('auth_register_title')}</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="name">{t('field_name')}</Label>
              <Input id="name" required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} data-testid="reg-name" />
            </div>
            <div>
              <Label htmlFor="email">{t('field_email')}</Label>
              <Input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="reg-email" />
            </div>
            <div>
              <Label htmlFor="password">{t('field_password')}</Label>
              <Input id="password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="reg-password" />
            </div>
            <div>
              <Label>{t('field_role')}</Label>
              <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
                <SelectTrigger data-testid="reg-role"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="teacher">{t('role_teacher')}</SelectItem>
                  <SelectItem value="parent">{t('role_parent')}</SelectItem>
                  <SelectItem value="student">{t('role_student')}</SelectItem>
                  <SelectItem value="admin">{t('role_admin')}</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <Button type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary/90 h-11" data-testid="reg-submit">
              {busy ? t('loading') : t('submit_register')}
            </Button>
          </form>
          <p className="text-sm text-muted-foreground mt-4 text-center">
            {t('have_account')} <Link to="/login" className="text-primary font-semibold hover:underline" data-testid="goto-login">{t('nav_login')}</Link>
          </p>
        </CardContent>
      </Card>
    </main>
  );
}
